import { AlertTriangle } from 'lucide-react';
import { cn } from '@tsgecart/ui';

export interface AdminErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  className?: string;
}

/**
 * Used for isolated widget-level failures (Part 14 "no blank page on one
 * failed widget") -- one card/chart failing to load renders this in its
 * own boundary instead of taking down the rest of the dashboard.
 */
export function AdminErrorState({
  title = 'Something went wrong',
  message,
  onRetry,
  className,
}: AdminErrorStateProps) {
  return (
    <div
      role="alert"
      className={cn('flex flex-col items-center justify-center gap-2 px-4 py-10 text-center', className)}
    >
      <AlertTriangle className="h-8 w-8 text-red-400" aria-hidden="true" />
      <p className="text-sm font-medium text-gray-900">{title}</p>
      <p className="max-w-xs text-sm text-gray-500">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="focus-visible:ring-brand mt-1 rounded-full border border-gray-200 px-4 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
        >
          Retry
        </button>
      )}
    </div>
  );
}
